import { FC, useEffect, useRef } from 'react';
import { useAppDispatch } from '../hooks/redux-hooks';
import { setReplyText } from '../store/chat.slice';

interface TextSelectionPopupProps {
  selectedText: string;
  position: { x: number; y: number };
  onClose: () => void;
}

const TextSelectionPopup: FC<TextSelectionPopupProps> = ({
  selectedText,
  position,
  onClose,
}) => {
  const popupRef = useRef<HTMLDivElement>(null);
  const dispatch = useAppDispatch();

  const onReply = (text: string) => {
    dispatch(setReplyText(text));
    onClose();
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        popupRef.current &&
        !popupRef.current.contains(event.target as Node)
      ) {
        onClose();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [onClose]);

  return (
    <div
      ref={popupRef}
      className="
        fixed z-50 min-w-[140px] bg-white dark:bg-[#2c2c2c] rounded-xl shadow-lg
        border border-gray-200 dark:border-gray-700 flex flex-col gap-1 p-1
      "
      style={{
        left: `${position.x}px`,
        top: `${position.y}px`,
      }}
    >
      <button
        onClick={() => onReply(selectedText)}
        className="
          px-1 py-1 text-sm font-medium text-gray-700 dark:text-gray-200
          hover:bg-gray-100 dark:hover:bg-gray-700 rounded-xl
          transition-colors duration-150 flex items-center gap-1
        "
      >
        <i className="icon-quotes text-base"></i>
        Ask Assistant
      </button>
    </div>
  );
};

export default TextSelectionPopup;
